import { render, staticRenderFns } from "./DoubletDlg.vue?vue&type=template&id=559aae8c&scoped=true"
import script from "./DoubletDlg.vue?vue&type=script&lang=js"
export * from "./DoubletDlg.vue?vue&type=script&lang=js"
import style0 from "./DoubletDlg.vue?vue&type=style&index=0&id=559aae8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559aae8c",
  null
  
)

export default component.exports